import { requestAlegriia } from "@utils/requests";
import { create } from "zustand";

interface AuthState {
  token: string | null;
  setToken: (token: string | null) => void;
  logout: () => Promise<void>;
}

export const useAuthStore = create<AuthState>((set) => ({
  token: "", // Is important that token is initialized with "" because the hook useRedirection need it
  setToken: (token) => set({ token }),
  logout: async () => {
    try {
      await requestAlegriia.post(
        "/logout",
        {},
        {
          withCredentials: true,
        }
      );
    } catch (err) {
      console.log("Error al cerrar sesión:", err);
    } finally {
      set({ token: "" });
    }
  },
}));
